import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { getDashboardPaymentOrderRefundItem } from "../../services/PaymentCollection/DashboardPaymentCollection";
import { getStoreLocalData } from "../../utils/localStorage";

export default function DashboardPaymentRefundItem({
  dashboardPaymentRefundItemModalVisible,
  setDashboardPaymentRefundItemModalVisible,
  selectedPaymentRefundItemValue,
}) {
  const [refundData, setRefundData] = useState(null);

  const { storeLocalData } = getStoreLocalData();

  const getRefundData = async (id) => {
    try {
      const response = await getDashboardPaymentOrderRefundItem(id);
      if (!response.data.error) {
        setRefundData(response.data);
      }
    } catch (error) {
      console.error("Error fetching payment collection data", error);
    }
  };

  useEffect(() => {
    if (selectedPaymentRefundItemValue?.id) {
      getRefundData(selectedPaymentRefundItemValue?.id);
    }
  }, [selectedPaymentRefundItemValue?.id]);

  const handleModalClose = () => {
    setDashboardPaymentRefundItemModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={dashboardPaymentRefundItemModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!dashboardPaymentRefundItemModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
          className="flex flex-column  gap-2"
            style={{
              borderRadius: "12px",
              backgroundImage:
                "radial-gradient(circle at left top, #fff, #fff)",
            }}
          >
           <div
              className="flex justify-content-between align-items-center gap-2 border-round-top"
              style={{
                
                backgroundImage:
                  "radial-gradient(circle at left top, #1752AA, #1752AA)",
              }}
            >
              <p></p>
              <p className=" text-3xl text-primary-50 font-semibold">
              Invoice No. - {refundData?.orderInfo?.invoiceNo}
              </p>
              <div className="mx-4 my-2">
                <i
                  className="pi pi-times"
                  onClick={(e) => hide(e)}
                  style={{ fontSize: "25px", color: "red", cursor: "pointer" }}
                ></i>
              </div>
            </div>
            <div className="flex-row mx-4">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">Booked By:</p>
                <p className="text-lg font-bold capitalize">
                  {refundData?.orderInfo?.bookedBy}
                </p>
              </div>
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">Refund By:</p>
                <p className="text-lg font-bold capitalize">
                  {refundData?.refundUserInfo?.fullName}
                </p>
              </div>
            </div>
            <div className="flex-row mx-4">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Paid Amount:
                </p>
                <p className="text-lg font-bold capitalize">
                  {storeLocalData?.currencySymbol} {refundData?.orderInfo?.paidAmount}
                </p>
              </div>
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Refund Amount:
                </p>
                <p className="text-lg font-bold capitalize">
                  {storeLocalData?.currencySymbol} {refundData?.orderInfo?.refundAmount}
                </p>
              </div>
            </div>

            <div className="flex-row mx-4">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">Status:</p>
                <p className="text-lg font-bold capitalize">
                  {refundData?.orderInfo?.status}
                </p>
              </div>
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Order Source:
                </p>
                <p className="text-lg font-bold capitalize">
                  {refundData?.orderInfo?.orderSource?.replace(/_/g, " ")}
                </p>
              </div>
            </div>

            <div className="flex-row mx-4">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Store Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {refundData?.orderInfo?.store?.storeName}
                </p>
              </div>
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Payment Mode:
                </p>
                <p className="text-lg font-bold capitalize">
                  {refundData?.paymentMode}
                </p>
              </div>
            </div>
          </div>
        )}
      ></Dialog>
      <div></div>
    </div>
  );
}
